module.exports = __webpack_public_path__ + "img/logo.72ff7e20.png";